<form [formGroup]="formGroup" id="step3Form">
  <div class="step3-form-container">
    <div class="row" [class.mark-red-border]="controls.currentlyDetained.value === true && mode === 'employee'">
      <div
        *ngIf="controls.currentlyDetained as currentlyDetained"
        class="standard-form-field radio-form-field currentlyDetained-field required-field">
        <label id="currentlyDetainedLabel" [class.invalid]="currentlyDetained.touched && currentlyDetained.invalid">
          {{ 'PERSONAL_DATA_FORM.CURRENTLY-DETAINED.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="currentlyDetained"
          formControlName="currentlyDetained"
          [required]="true"
          [attr.aria-labelledby]="'currentlyDetainedLabel'"
          [attr.aria-invalid]="currentlyDetained.touched && currentlyDetained.invalid ? 'true' : null"
          (keydown)="firstInputKeydown($event)">
          <mat-radio-button id="currentlyDetained-0" [value]="true">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <ng-container *ngIf="controls.currentlyDetained.value === true">
      <!-- ====================================================================== 1 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inGuardedCentre.value === true && mode === 'employee'">
        <div
          *ngIf="controls.inGuardedCentre as inGuardedCentre"
          class="standard-form-field radio-form-field inGuardedCentre-field required-field">
          <label id="inGuardedCentreLabel" [class.invalid]="inGuardedCentre.touched && inGuardedCentre.invalid">
            {{ 'PERSONAL_DATA_FORM.DETAINED_IN_GUARDED_CENTRE' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="inGuardedCentre"
            formControlName="inGuardedCentre"
            [required]="true"
            [attr.aria-labelledby]="'inGuardedCentreLabel'"
            [attr.aria-invalid]="inGuardedCentre.touched && inGuardedCentre.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="controls.inGuardedCentre.value === true">
          <div
            *ngIf="controls.inGuardedCentreComment as inGuardedCentreComment"
            class="standard-form-field three-fourth-field inGuardedCentreComment-field">
            <label
              for="inGuardedCentreComment"
              [class.invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid">
              {{ 'COMMON.LABEL.COMMENT' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="inGuardedCentreComment"
                formControlName="inGuardedCentreComment"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  inGuardedCentreComment.touched && inGuardedCentreComment.invalid
                    ? 'inGuardedCentreCommentError'
                    : null
                "></textarea>

              <!-- ERROR -->
              <mat-error
                *ngIf="inGuardedCentreComment.touched && inGuardedCentreComment.invalid"
                id="inGuardedCentreCommentError">
                {{ inGuardedCentreComment.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <!-- ====================================================================== 2 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inDetentionCentre.value === true && mode === 'employee'">
        <div
          *ngIf="controls.inDetentionCentre as inDetentionCentre"
          class="standard-form-field radio-form-field inDetentionCentre-field required-field">
          <label id="inDetentionCentreLabel" [class.invalid]="inDetentionCentre.touched && inDetentionCentre.invalid">
            {{ 'PERSONAL_DATA_FORM.IN_DETENTION_CENTRE' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="inDetentionCentre"
            formControlName="inDetentionCentre"
            [required]="true"
            [attr.aria-labelledby]="'inDetentionCentreLabel'"
            [attr.aria-invalid]="inDetentionCentre.touched && inDetentionCentre.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="controls.inDetentionCentre.value === true">
          <div
            *ngIf="controls.inDetentionCentreComment as inDetentionCentreComment"
            class="standard-form-field three-fourth-field inDetentionCentreComment-field">
            <label
              for="inDetentionCentreComment"
              [class.invalid]="inDetentionCentreComment.touched && inDetentionCentreComment.invalid">
              {{ 'COMMON.LABEL.COMMENT' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="inDetentionCentreComment"
                formControlName="inDetentionCentreComment"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  inDetentionCentreComment.touched && inDetentionCentreComment.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  inDetentionCentreComment.touched && inDetentionCentreComment.invalid
                    ? 'inDetentionCentreCommentError'
                    : null
                "></textarea>

              <!-- ERROR -->
              <mat-error
                *ngIf="inDetentionCentreComment.touched && inDetentionCentreComment.invalid"
                id="inDetentionCentreCommentError">
                {{ inDetentionCentreComment.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <!-- ====================================================================== 3 ============================= -->
      <div class="row" [class.mark-red-border]="controls.hasBanOnLeavingCountry.value === true && mode === 'employee'">
        <div
          *ngIf="controls.hasBanOnLeavingCountry as hasBanOnLeavingCountry"
          class="standard-form-field radio-form-field hasBanOnLeavingCountry-field required-field">
          <label
            id="hasBanOnLeavingCountryLabel"
            [class.invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid">
            {{ 'PERSONAL_DATA_FORM.HAS_BAN_ON_LEAVING_THE_COUNTRY' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasBanOnLeavingCountry"
            formControlName="hasBanOnLeavingCountry"
            [required]="true"
            [attr.aria-labelledby]="'hasBanOnLeavingCountryLabel'"
            [attr.aria-invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="controls.hasBanOnLeavingCountry.value === true">
          <div
            *ngIf="controls.hasBanOnLeavingCountryComment as hasBanOnLeavingCountryComment"
            class="standard-form-field three-fourth-field hasBanOnLeavingCountryComment-field">
            <label
              for="hasBanOnLeavingCountryComment"
              [class.invalid]="hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid">
              {{ 'COMMON.LABEL.COMMENT' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="hasBanOnLeavingCountryComment"
                formControlName="hasBanOnLeavingCountryComment"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid
                    ? 'hasBanOnLeavingCountryCommentError'
                    : null
                "></textarea>

              <!-- ERROR -->
              <mat-error
                *ngIf="hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid"
                id="hasBanOnLeavingCountryCommentError">
                {{ hasBanOnLeavingCountryComment.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <!-- ====================================================================== 4 ============================= -->
      <div
        class="row"
        [class.mark-red-border]="controls.hasSentenceOfImprisonment.value === true && mode === 'employee'">
        <div
          *ngIf="controls.hasSentenceOfImprisonment as hasSentenceOfImprisonment"
          class="standard-form-field radio-form-field hasSentenceOfImprisonment-field required-field">
          <label
            id="hasSentenceOfImprisonmentLabel"
            [class.invalid]="hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid">
            {{ 'PERSONAL_DATA_FORM.SENTENCED_IMPRISONMENT' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasSentenceOfImprisonment"
            formControlName="hasSentenceOfImprisonment"
            [required]="true"
            [attr.aria-labelledby]="'hasSentenceOfImprisonmentLabel'"
            [attr.aria-invalid]="
              hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="controls.hasSentenceOfImprisonment.value === true">
          <div
            *ngIf="controls.hasSentenceOfImprisonmentComment as hasSentenceOfImprisonmentComment"
            class="standard-form-field three-fourth-field hasSentenceOfImprisonmentComment-field">
            <label
              for="hasSentenceOfImprisonmentComment"
              [class.invalid]="hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid">
              {{ 'COMMON.LABEL.COMMENT' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="hasSentenceOfImprisonmentComment"
                formControlName="hasSentenceOfImprisonmentComment"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid
                    ? 'hasSentenceOfImprisonmentCommentError'
                    : null
                "></textarea>

              <!-- ERROR -->
              <mat-error
                *ngIf="hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid"
                id="hasSentenceOfImprisonmentCommentError">
                {{ hasSentenceOfImprisonmentComment.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <!-- ====================================================================== 5 ============================= -->
      <div class="row" [class.mark-red-border]="controls.temporarilyArrested.value === true && mode === 'employee'">
        <div
          *ngIf="controls.temporarilyArrested as temporarilyArrested"
          class="standard-form-field radio-form-field temporarilyArrested-field required-field">
          <label
            id="temporarilyArrestedLabel"
            [class.invalid]="temporarilyArrested.touched && temporarilyArrested.invalid">
            {{ 'PERSONAL_DATA_FORM.TEMPORARILY_ARRESTED' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="temporarilyArrested"
            formControlName="temporarilyArrested"
            [required]="true"
            [attr.aria-labelledby]="'temporarilyArrestedLabel'"
            [attr.aria-invalid]="temporarilyArrested.touched && temporarilyArrested.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <ng-container *ngIf="controls.temporarilyArrested.value === true">
          <div
            *ngIf="controls.temporarilyArrestedComment as temporarilyArrestedComment"
            class="standard-form-field three-fourth-field temporarilyArrestedComment-field">
            <label
              for="temporarilyArrestedComment"
              [class.invalid]="temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid">
              {{ 'COMMON.LABEL.COMMENT' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="temporarilyArrestedComment"
                formControlName="temporarilyArrestedComment"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid
                    ? 'temporarilyArrestedCommentError'
                    : null
                "></textarea>

              <!-- ERROR -->
              <mat-error
                *ngIf="temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid"
                id="temporarilyArrestedCommentError">
                {{ temporarilyArrestedComment.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.wasSentencedInPoland as wasSentencedInPoland"
        class="standard-form-field radio-form-field wasSentencedInPoland-field required-field">
        <label
          id="wasSentencedInPolandLabel"
          [class.invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid">
          {{ 'PERSONAL_DATA_FORM.WAS-SENTENCED-IN-POLAND.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="wasSentencedInPoland"
          formControlName="wasSentencedInPoland"
          [required]="true"
          [attr.aria-labelledby]="'wasSentencedInPolandLabel'"
          [attr.aria-invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid ? 'true' : null">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container *ngIf="controls.wasSentencedInPoland.value === true">
        <div
          *ngIf="controls.sentenceReason as sentenceReason"
          class="standard-form-field three-fourth-field sentenceReason-field">
          <label for="applicantSentenceReason" [class.invalid]="sentenceReason.touched && sentenceReason.invalid">
            {{ 'PERSONAL_DATA_FORM.SENTENCE-REASON.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              id="applicantSentenceReason"
              formControlName="sentenceReason"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="9"
              [attr.aria-required]="false"
              [attr.aria-invalid]="sentenceReason.touched && sentenceReason.invalid ? 'true' : null"
              [attr.aria-describedby]="
                sentenceReason.touched && sentenceReason.invalid ? 'sentenceReasonError' : null
              "></textarea>

            <!-- ERROR -->
            <mat-error *ngIf="sentenceReason.touched && sentenceReason.invalid" id="sentenceReasonError">
              {{ sentenceReason.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="row">
      <div
        *ngIf="controls.currentlySubjectOfProceedings as currentlySubjectOfProceedings"
        class="standard-form-field radio-form-field currentlySubjectOfProceedings-field required-field">
        <label
          id="currentlySubjectOfProceedingsLabel"
          [class.invalid]="currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid">
          {{ 'PERSONAL_DATA_FORM.CURRENTLY-SUBJECT-OF-PROCEEDINGS.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="currentlySubjectOfProceedings"
          formControlName="currentlySubjectOfProceedings"
          [required]="true"
          [attr.aria-labelledby]="'currentlySubjectOfProceedingsLabel'"
          [attr.aria-invalid]="
            currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container *ngIf="controls.currentlySubjectOfProceedings.value === true">
        <div
          *ngIf="controls.proceedingsReason as proceedingsReason"
          class="standard-form-field three-fourth-field proceedingsReason-field">
          <label
            for="applicantProceedingsReason"
            [class.invalid]="proceedingsReason.touched && proceedingsReason.invalid">
            {{ 'PERSONAL_DATA_FORM.PROCEEDINGS-REASON.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              id="applicantProceedingsReason"
              formControlName="proceedingsReason"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="9"
              [attr.aria-required]="false"
              [attr.aria-invalid]="proceedingsReason.touched && proceedingsReason.invalid ? 'true' : null"
              [attr.aria-describedby]="
                proceedingsReason.touched && proceedingsReason.invalid ? 'proceedingsReasonError' : null
              "></textarea>

            <!-- ERROR -->
            <mat-error *ngIf="proceedingsReason.touched && proceedingsReason.invalid" id="proceedingsReasonError">
              {{ proceedingsReason.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="row">
      <div
        *ngIf="controls.isComplyingWithFiscalObligation as isComplyingWithFiscalObligation"
        class="standard-form-field radio-form-field isComplyingWithFiscalObligation-field required-field">
        <label
          id="isComplyingWithFiscalObligationLabel"
          [class.invalid]="isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid">
          {{ 'PERSONAL_DATA_FORM.IS-COMPLYING-WITH-FISCAL-OBLIGATION.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="isComplyingWithFiscalObligation"
          formControlName="isComplyingWithFiscalObligation"
          [required]="true"
          [attr.aria-labelledby]="'isComplyingWithFiscalObligationLabel'"
          [attr.aria-invalid]="
            isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid ? 'true' : null
          "
          (keydown.Tab)="
            maritalStatus === 'Żonaty' || maritalStatus === 'Mężatka' ? undefined : emitLastFieldTabPressed($event)
          ">
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="maritalStatus === 'Żonaty' || maritalStatus === 'Mężatka'">
      <nz-divider [nzText]="travelers" nzOrientation="center">
        <ng-template #travelers>
          <h5>{{ 'PERSONAL_DATA_FORM.SPOUSE_DATA' | translate }}</h5>
        </ng-template>
      </nz-divider>

      <div class="row">
        <div *ngIf="controls.spouseName as spouseName" class="standard-form-field spouseName-field required-field">
          <label for="spouseNameInput" [class.invalid]="spouseName.touched && spouseName.invalid">
            {{ 'PERSONAL_DATA_FORM.NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseNameInput"
              type="text"
              maxlength="200"
              placeholder="{{ 'PERSONAL_DATA_FORM.NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="spouseName.touched && spouseName.invalid ? 'true' : null"
              [attr.aria-describedby]="spouseName.touched && spouseName.invalid ? 'spouseNameError' : null"
              [formControl]="spouseName" />

            <!-- ERROR -->
            <mat-error *ngIf="spouseName.touched && spouseName.invalid" id="spouseNameError">
              {{ spouseName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.spouseSurname as spouseSurname"
          class="standard-form-field spouseSurname-field required-field">
          <label for="spouseSurnameInput" [class.invalid]="spouseSurname.touched && spouseSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.SURNAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseSurnameInput"
              type="text"
              maxlength="200"
              placeholder="{{ 'PERSONAL_DATA_FORM.SURNAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="spouseSurname.touched && spouseSurname.invalid ? 'true' : null"
              [attr.aria-describedby]="spouseSurname.touched && spouseSurname.invalid ? 'spouseSurnameError' : null"
              [formControl]="spouseSurname" />

            <!-- ERROR -->
            <mat-error *ngIf="spouseSurname.touched && spouseSurname.invalid" id="spouseSurnameError">
              {{ spouseSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.spousePreviousName as spousePreviousName"
          class="standard-form-field spousePreviousName-field">
          <label
            for="spousePreviousNameInput"
            [class.invalid]="spousePreviousName.touched && spousePreviousName.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spousePreviousNameInput"
              type="text"
              maxlength="200"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="spousePreviousName.touched && spousePreviousName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                spousePreviousName.touched && spousePreviousName.invalid ? 'spousePreviousNameError' : null
              "
              [formControl]="spousePreviousName" />

            <!-- ERROR -->
            <mat-error *ngIf="spousePreviousName.touched && spousePreviousName.invalid" id="spousePreviousNameError">
              {{ spousePreviousName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.spousePreviousSurname as spousePreviousSurname"
          class="standard-form-field spousePreviousSurname-field">
          <label
            for="spousePreviousSurnameInput"
            [class.invalid]="spousePreviousSurname.touched && spousePreviousSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spousePreviousSurnameInput"
              type="text"
              maxlength="200"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="spousePreviousSurname.touched && spousePreviousSurname.invalid ? 'true' : null"
              [attr.aria-describedby]="
                spousePreviousSurname.touched && spousePreviousSurname.invalid ? 'spousePreviousSurnameError' : null
              "
              [formControl]="spousePreviousSurname" />

            <!-- ERROR -->
            <mat-error
              *ngIf="spousePreviousSurname.touched && spousePreviousSurname.invalid"
              id="spousePreviousSurnameError">
              {{ spousePreviousSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div *ngIf="controls.spouseDob as spouseDob" class="standard-form-field spouseDob-field required-field">
          <label for="spouseDobInput" [class.invalid]="spouseDob.touched && spouseDob.invalid">
            {{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="picker.open()">
            <input
              matInput
              (focus)="picker.open()"
              id="spouseDobInput"
              #spouseDobInput
              [matDatepicker]="picker"
              placeholder="{{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.PLACEHOLDER' | translate }}"
              [min]="minValidDate"
              [max]="maxValidDate"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="spouseDob.touched && spouseDob.invalid ? 'true' : null"
              [attr.aria-describedby]="spouseDob.touched && spouseDob.invalid ? 'spouseDobError' : null"
              [readonly]="true"
              [formControl]="spouseDob" />

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #picker
              [startView]="'month'"
              [startAt]="'1985'"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="spouseDobInput.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error *ngIf="spouseDob.touched && spouseDob.invalid" id="spouseDobError">
              {{ spouseDob.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.spouseSex as spouseSex" class="standard-form-field spouseSex-field required-field">
          <label id="spouseSexLabel" [class.invalid]="spouseSex.touched && spouseSex.invalid">
            {{ 'PERSONAL_DATA_FORM.SEX.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              [formControl]="spouseSex"
              id="spouseSexInput"
              panelClass="standard-select"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-labelledby]="'spouseSexLabel'"
              [attr.aria-invalid]="spouseSex.touched && spouseSex.invalid ? 'true' : null"
              [attr.aria-describedby]="spouseSex.touched && spouseSex.invalid ? 'spouseSexError' : null">
              <mat-option *ngFor="let item of selectsValues.SEX" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="spouseSex.touched && spouseSex.invalid" id="spouseSexError">
              {{ spouseSex.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="standard-form-field citizenship-field required-field">
          <!-- Filtering out id: 616 -> Poland. Person that has Polish citizenship cannot apply for temp. permit -->
          <app-country-select
            class="country-select"
            [fieldControl]="controls.spouseCitizenship"
            [fieldKey]="'spouseCitizenship'"
            [isRequired]="true"
            [fieldLabelKey]="'CITIZENSHIP'">
          </app-country-select>
        </div>
      </div>

      <div class="row">
        <div class="standard-form-field spouseResidenceCountry-field">
          <app-country-select
            class="country-select"
            [fieldControl]="controls.spouseResidenceCountry"
            [fieldKey]="'spouseResidenceCountry'"
            [isRequired]="false"
            [fieldLabelKey]="'RESIDENCE-COUNTRY'">
          </app-country-select>
        </div>
        <div
          *ngIf="controls.spouseResidencePostalCode as spouseResidencePostalCode"
          class="standard-form-field spouseResidencePostalCode-field">
          <label
            for="spouseResidencePostalCodeInput"
            [class.invalid]="spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseResidencePostalCodeInput"
              type="text"
              maxLength="6"
              minLength="6"
              [mask]="'99-999'"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="
                spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid
                  ? 'spouseResidencePostalCodeError'
                  : null
              "
              [formControl]="spouseResidencePostalCode" />

            <!-- ERROR -->
            <mat-error
              *ngIf="spouseResidencePostalCode.touched && spouseResidencePostalCode.invalid"
              id="spouseResidencePostalCodeError">
              {{ spouseResidencePostalCode.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngIf="controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska'">
          <div
            *ngIf="controls.spouseResidenceVoivodeshipDetailsId as spouseResidenceVoivodeshipDetailsId"
            class="standard-form-field spouseResidenceVoivodeshipDetailsId-field">
            <label
              id="spouseResidenceVoivodeshipDetailsIdLabel"
              [class.invalid]="
                spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
              ">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline" *ngIf="voivodeships$ | async as voivodeships">
              <mat-select
                [formControl]="spouseResidenceVoivodeshipDetailsId"
                id="spouseResidenceVoivodeshipDetailsId"
                panelClass="['standard-select', longer-select']"
                [attr.aria-required]="false"
                [attr.aria-labelledby]="'spouseResidenceVoivodeshipDetailsIdLabel'"
                [attr.aria-invalid]="
                  spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
                    ? 'true'
                    : null
                "
                [attr.aria-describedby]="
                  spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid
                    ? 'spouseResidenceVoivodeshipDetailsIdError'
                    : null
                ">
                <mat-option *ngFor="let voivo of voivodeships" [value]="voivo.id">
                  {{ 'COMMON.VOIVODESHIPS.' + voivo.key | translate }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceVoivodeshipDetailsId.touched && spouseResidenceVoivodeshipDetailsId.invalid"
                id="spouseResidenceVoivodeshipDetailsIdError">
                {{ spouseResidenceVoivodeshipDetailsId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="controls.spouseResidenceCountry?.value?.toLowerCase() !== 'polska'">
          <div
            *ngIf="controls.spouseResidenceCity as spouseResidenceCity"
            class="standard-form-field spouseResidenceCity-field">
            <label
              for="spouseResidenceCityInput"
              [class.invalid]="spouseResidenceCity.touched && spouseResidenceCity.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseResidenceCityInput"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="spouseResidenceCity.touched && spouseResidenceCity.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  spouseResidenceCity.touched && spouseResidenceCity.invalid ? 'spouseResidenceCityError' : null
                "
                [formControl]="spouseResidenceCity" />

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceCity.touched && spouseResidenceCity.invalid"
                id="spouseResidenceCityError">
                {{ spouseResidenceCity.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <div class="row">
        <ng-container *ngIf="controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska'">
          <div
            *ngIf="controls.spouseResidenceDistrictId as spouseResidenceDistrictId"
            class="standard-form-field spouseResidenceDistrictId-field">
            <label
              id="spouseResidenceDistrictIdLabel"
              [class.invalid]="spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid">
              {{ 'COMMON.LABEL.DISTRICT' | translate }}
            </label>
            <mat-form-field appearance="outline" *ngIf="districts$ | async as districts">
              <mat-select
                [formControl]="spouseResidenceDistrictId"
                [disabled]="!controls.spouseResidenceVoivodeshipDetailsId?.value"
                id="spouseResidenceDistrictId"
                [panelClass]="['standard-select', 'longer-select']"
                appMatOptionHeight
                [appMatOptionHeightValue]="50"
                [attr.aria-required]="false"
                [attr.aria-labelledby]="'spouseResidenceDistrictIdLabel'"
                [attr.aria-invalid]="
                  spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid
                    ? 'spouseResidenceDistrictIdError'
                    : null
                "
                class="heightened-select">
                <mat-option *ngIf="loadingDistricts$ | async" role="status" aria-live="polite">
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>

                  <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
                </mat-option>

                <mat-option *ngFor="let district of districts" [value]="district.id">
                  {{ district.MOS_name.toUpperCase() }} ({{ district.MOS_extra_name.toUpperCase() }})
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceDistrictId.touched && spouseResidenceDistrictId.invalid"
                id="spouseResidenceDistrictIdError">
                {{ spouseResidenceDistrictId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.spouserResidenceMunicipalityId as spouserResidenceMunicipalityId"
            class="standard-form-field spouserResidenceMunicipalityId-field">
            <label
              id="spouserResidenceMunicipalityIdlabel"
              [class.invalid]="spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid">
              {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
            </label>
            <mat-form-field appearance="outline" *ngIf="municips$ | async as municips">
              <mat-select
                [formControl]="spouserResidenceMunicipalityId"
                [disabled]="!controls.spouseResidenceDistrictId?.value"
                id="spouserResidenceMunicipalityId"
                [panelClass]="['standard-select', 'longer-select']"
                appMatOptionHeight
                [appMatOptionHeightValue]="50"
                [attr.aria-required]="false"
                [attr.aria-labelledby]="'spouserResidenceMunicipalityIdlabel'"
                [attr.aria-invalid]="
                  spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid
                    ? 'spouserResidenceMunicipalityIdError'
                    : null
                ">
                <mat-option *ngIf="loadingMunicips$ | async" role="status" aria-live="polite">
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>

                  <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
                </mat-option>

                <mat-option *ngFor="let municip of municips" [value]="municip.id">
                  {{ municip.MOS_name.toUpperCase() }} ({{ municip.MOS_type.toUpperCase() }})
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouserResidenceMunicipalityId.touched && spouserResidenceMunicipalityId.invalid"
                id="spouserResidenceMunicipalityIdError">
                {{ spouserResidenceMunicipalityId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.spouseResidenceCityListedId as spouseResidenceCityListedId"
            class="standard-form-field spouseResidenceCityListedId-field">
            <label
              id="spouseResidenceCityListedIdLabel"
              [class.invalid]="spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid">
              {{ 'COMMON.LABEL.CITY_MOS' | translate }}
            </label>
            <mat-form-field appearance="outline" *ngIf="cities$ | async as cities">
              <mat-select
                [formControl]="spouseResidenceCityListedId"
                [disabled]="!controls.spouserResidenceMunicipalityId?.value"
                id="spouseResidenceCityListedId"
                [panelClass]="['standard-select', 'longer-select']"
                appMatOptionHeight
                [appMatOptionHeightValue]="50"
                [attr.aria-required]="false"
                [attr.aria-labelledby]="'spouseResidenceCityListedIdLabel'"
                [attr.aria-invalid]="
                  spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid
                    ? 'spouseResidenceCityListedIdError'
                    : null
                ">
                <mat-option *ngIf="loadingCities$ | async" role="status" aria-live="polite">
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>

                  <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
                </mat-option>

                <mat-option *ngFor="let city of cities" [value]="city.id">
                  {{ city.MOS_name.toUpperCase() }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceCityListedId.touched && spouseResidenceCityListedId.invalid"
                id="spouseResidenceCityListedIdError">
                {{ spouseResidenceCityListedId.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="controls.spouseResidenceCountry?.value?.toLowerCase() !== 'polska'">
          <div
            *ngIf="controls.spouseResidenceStreet as spouseResidenceStreet"
            class="standard-form-field spouseResidenceStreet-field">
            <label
              for="spouseResidenceStreetInput"
              [class.invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid">
              {{ 'COMMON.LABEL.STREET_NAME' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseResidenceStreetInput"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  spouseResidenceStreet.touched && spouseResidenceStreet.invalid
                    ? 'spouseResidenceStreetError spouseResidenceStreetTooltip'
                    : 'spouseResidenceStreetTooltip'
                "
                [formControl]="spouseResidenceStreet" />

              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'spouseResidenceStreetTooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceStreet.touched && spouseResidenceStreet.invalid"
                id="spouseResidenceStreetError">
                {{ spouseResidenceStreet.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.spouseResidenceHouseNumber as spouseResidenceHouseNumber"
            class="standard-form-field spouseResidenceHouseNumber-field">
            <label
              for="spouseResidenceHouseNumberInput"
              [class.invalid]="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseResidenceHouseNumberInput"
                type="text"
                maxLength="20"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid
                    ? 'spouseResidenceHouseNumberError spouseResidenceHouseNumberTooltip'
                    : 'spouseResidenceHouseNumberTooltip'
                "
                [formControl]="spouseResidenceHouseNumber" />

              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'spouseResidenceHouseNumberTooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid"
                id="spouseResidenceHouseNumberError">
                {{ spouseResidenceHouseNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="controls.spouseResidenceApartmentNumber as spouseResidenceApartmentNumber"
            class="standard-form-field spouseResidenceApartmentNumber-field">
            <label
              for="spouseResidenceApartmentNumberInput"
              [class.invalid]="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="spouseResidenceApartmentNumberInput"
                type="text"
                maxLength="20"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="
                  spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid
                    ? 'spouseResidenceApartmentNumberError spouseResidenceApartmentNumberTooltip'
                    : 'spouseResidenceApartmentNumberTooltip'
                "
                [formControl]="spouseResidenceApartmentNumber"
                (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />

              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'spouseResidenceApartmentNumberTooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>

              <!-- ERROR -->
              <mat-error
                *ngIf="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid"
                id="spouseResidenceApartmentNumberError">
                {{ spouseResidenceApartmentNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <div class="row" *ngIf="controls.spouseResidenceCountry?.value?.toLowerCase() === 'polska'">
        <div
          *ngIf="controls.spouseResidenceStreet as spouseResidenceStreet"
          class="standard-form-field spouseResidenceStreet-field">
          <label
            for="spouseResidenceStreetInputPoland"
            [class.invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid">
            {{ 'COMMON.LABEL.STREET_NAME' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseResidenceStreetInputPoland"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="spouseResidenceStreet.touched && spouseResidenceStreet.invalid ? 'true' : null"
              [attr.aria-describedby]="
                spouseResidenceStreet.touched && spouseResidenceStreet.invalid
                  ? 'spouseResidenceStreetError spouseResidenceStreetTooltip'
                  : 'spouseResidenceStreetTooltip'
              "
              [formControl]="spouseResidenceStreet" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'spouseResidenceStreetTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="spouseResidenceStreet.touched && spouseResidenceStreet.invalid"
              id="spouseResidenceStreetError">
              {{ spouseResidenceStreet.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.spouseResidenceHouseNumber as spouseResidenceHouseNumber"
          class="standard-form-field spouseResidenceHouseNumber-field">
          <label
            for="spouseResidenceHouseNumberInputPoland"
            [class.invalid]="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseResidenceHouseNumberInputPoland"
              type="text"
              maxLength="20"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="
                spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid
                  ? 'spouseResidenceHouseNumberError spouseResidenceHouseNumberTooltip'
                  : 'spouseResidenceHouseNumberTooltip'
              "
              [formControl]="spouseResidenceHouseNumber" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'spouseResidenceHouseNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="spouseResidenceHouseNumber.touched && spouseResidenceHouseNumber.invalid"
              id="spouseResidenceHouseNumberError">
              {{ spouseResidenceHouseNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.spouseResidenceApartmentNumber as spouseResidenceApartmentNumber"
          class="standard-form-field spouseResidenceApartmentNumber-field">
          <label
            for="spouseResidenceApartmentNumberInputPoland"
            [class.invalid]="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="spouseResidenceApartmentNumberInputPoland"
              type="text"
              maxLength="20"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="
                spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid
                  ? 'spouseResidenceApartmentNumberError spouseResidenceApartmentNumberTooltip'
                  : 'spouseResidenceApartmentNumberTooltip'
              "
              [formControl]="spouseResidenceApartmentNumber"
              (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'spouseResidenceApartmentNumberTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error
              *ngIf="spouseResidenceApartmentNumber.touched && spouseResidenceApartmentNumber.invalid"
              id="spouseResidenceApartmentNumberError">
              {{ spouseResidenceApartmentNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</form>
